import { render, staticRenderFns } from "./GamesVersionSelect.vue?vue&type=template&id=831714ae&scoped=true&"
import script from "./GamesVersionSelect.vue?vue&type=script&lang=js&"
export * from "./GamesVersionSelect.vue?vue&type=script&lang=js&"
import style0 from "./GamesVersionSelect.vue?vue&type=style&index=0&id=831714ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831714ae",
  null
  
)

export default component.exports